import React from 'react';
import { IconShoppingBag } from '@tabler/icons-react';

const EquipmentSection = () => {
  return (
    <section className="ub-equipment-section">
      <div className="ub-equipment-placeholder">
        <IconShoppingBag size={64} color="#c41e3a" strokeWidth={1.5} />
        <p className="ub-placeholder-text">Equipment recommendations coming soon</p>
      </div>
    </section>
  );
};

export default EquipmentSection;
